import 'regenerator-runtime/runtime';
import { call, select, take } from 'redux-saga/effects';
import { GlobalActions, GlobalPut, isAzam } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { CrmKomm, CrmKommunikationSpeichernRequest, KommunikationsArt } from '@ps20/bff-models';
import { IAppState } from '@ps20-frontend/apps/checkout-store';
import { PS20Logger } from '@ps20-frontend/logging';
import { Versicherungsnehmer } from '../reducer/versicherungsnehmer.reducer';
import { CheckoutActions } from '../checkout.actions';
import { isSdwSession } from '../selector/transient-state.selector';

export enum KOMMUNIKATIONSDATEN_EVENTS {
  KOMMUNIKATIONSDATEN_SAVE_SUCCESSFUL = 'KOMMUNIKATIONSDATEN_SAVE_SUCCESSFUL',
  KOMMUNIKATIONSDATEN_SAVE_FAILED = 'KOMMUNIKATIONSDATEN_SAVE_FAILED',
}

export function* watchKommunikationsdatenAnlegen() {
  yield take(CheckoutActions.KOMMUNIKATIONSDATEN_ANLEGEN_REQUESTED);
  yield call(kommunikationsdatenAnlegenSaga);
}

function getNewKommunikationsdaten(versicherungsnehmer: Versicherungsnehmer): Array<CrmKomm> {
  const kommdaten: Array<CrmKomm> = [];

  const email = versicherungsnehmer.email;

  if (email?.vorbelegt === false && email.wert != null && email.wert !== '') {
    kommdaten.push({
      kommunikationsArt: KommunikationsArt.EMAIL,
      value: email.wert,
    });
  }
  const mobil = versicherungsnehmer.mobil;

  if (mobil?.vorbelegt === false && mobil.wert != null && mobil.wert !== '') {
    kommdaten.push({
      kommunikationsArt: KommunikationsArt.HANDY,
      value: mobil.wert,
    });
  }
  const telefon = versicherungsnehmer.telefon;

  if (telefon?.vorbelegt === false && telefon.wert != null && telefon.wert !== '') {
    kommdaten.push({
      kommunikationsArt: KommunikationsArt.TELEFON,
      value: telefon.wert,
    });
  }

  return kommdaten.length > 0 ? kommdaten : null;
}

export function* kommunikationsdatenAnlegenSaga() {
  try {
    const globalPut = GlobalPut.getInstance();
    const state: IAppState = yield select();

    const newKommunikationsdaten: Array<CrmKomm> = getNewKommunikationsdaten(
      state.versicherungsnehmer,
    );
    if (!isAzam(state.role) && newKommunikationsdaten && !isSdwSession(state)) {
      const body: CrmKommunikationSpeichernRequest = {
        personId: state.versicherungsnehmer.kundenverwaltungID,
        crmKommList: newKommunikationsdaten,
      };

      yield call(
        [globalPut, globalPut.put],
        new GlobalActions().doRequest({
          appId: App.SHOP_CHECKOUT,
          url: 'privatschutz/api/amiscrmKommunikationSpeichern',
          body,
          successEvent: KOMMUNIKATIONSDATEN_EVENTS.KOMMUNIKATIONSDATEN_SAVE_SUCCESSFUL,
          errorEvent: KOMMUNIKATIONSDATEN_EVENTS.KOMMUNIKATIONSDATEN_SAVE_FAILED,
        }),
      );
    }
  } catch (err) {
    PS20Logger.error(
      App.SHOP_CHECKOUT,
      'error in ' + kommunikationsdatenAnlegenSaga.name + ' @message: ' + err,
    );
  }
}
